import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const MindmapListLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.mindmap',
    link: '/mindmap/list',
    icon: 'navigation-link__list-item',
});